import { Tooltip } from 'react-tooltip'
import './UserRatingCharacteristic.scss'

interface ReviewDetails {
  id: number
  rating: string
  feedback?: string
  createdAt?: string
}

interface UserRatingCharacteristicProps {
  reviewDetails: ReviewDetails
  customerRating: string
}

const UserRatingCharacteristic: React.FC<UserRatingCharacteristicProps> = ({
  reviewDetails,
  customerRating
}) => {
  if (!reviewDetails) return null

  const rating = parseFloat(reviewDetails.rating) || 0

  let displayText = ''
  let bgColorClass = ''

  if (rating <= 2) {
    displayText = '🫤 Not for me'
    bgColorClass = 'user-rating--low'
  } else if (rating === 3) {
    displayText = '😌 It was ok'
    bgColorClass = 'user-rating--medium'
  } else {
    displayText = '🤩 Loved it'
    bgColorClass = 'user-rating--high'
  }

  const tooltipId = `rating-tooltip-${reviewDetails.id}`
  const userRating = parseFloat(reviewDetails.rating).toFixed(1)
  const customersRating = parseFloat(customerRating).toFixed(1)

  return (
    <>
      <div
        className={`user-rating ${bgColorClass}`}
        data-tooltip-id={tooltipId}>
        <div className="user-rating__inner-frame">
          <span className="user-rating__text">{displayText}</span>
        </div>
      </div>
      <Tooltip
        id={tooltipId}
        className="tooltip__theme-dark user-rating__tooltip"
        opacity={1}
        place="top">
        <div className="user-rating__tooltip-content">
          <div>Your rating: ★ {userRating}</div>
          {customerRating && <div>Customers rating: ★ {customersRating}</div>}
        </div>
      </Tooltip>
    </>
  )
}

export { UserRatingCharacteristic }
